import { FC } from 'react'
import styled from '@emotion/styled'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBars, faTimes } from '@fortawesome/free-solid-svg-icons'
import SettingsControl from '../SettingsControl'

interface IMobileMenuNewProps {
    isOpen: boolean
    onToggle: () => void
}

const MenuContainer = styled.div`
    position: relative;
`

const MenuButton = styled.button`
    background: none;
    border: none;
    cursor: pointer;
    padding: 8px;
    color: ${props => props.theme.colors.primary};
`

const MenuContent = styled.div<{ isOpen: boolean }>`
    position: absolute;
    top: 100%;
    right: 0;
    background: linear-gradient(135deg, rgba(40, 54, 72, 0.95) 0%, rgba(28, 37, 49, 0.95) 100%);
    border-radius: 8px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    padding: 16px;
    display: ${props => (props.isOpen ? 'block' : 'none')};
    min-width: 200px;
    z-index: 1000;
`

const MenuItem = styled.a`
    display: block;
    padding: 12px 16px;
    color: ${props => props.theme.colors.white};
    text-decoration: none;
`

const MobileMenuNew: FC<IMobileMenuNewProps> = ({ isOpen, onToggle }) => {
    return (
        <MenuContainer>
            <MenuButton onClick={onToggle}>
                <FontAwesomeIcon icon={isOpen ? faTimes : faBars} width={20} />
            </MenuButton>

            <MenuContent isOpen={isOpen}>
                <SettingsControl />
            </MenuContent>
        </MenuContainer>
    )
}

export default MobileMenuNew
